import "core-js/modules/es.object.keys.js";
import z from 'zod';
import { QuestionOptionsPropertySchema } from "../../types";
export var NodeType = /*#__PURE__*/function (NodeType) {
  NodeType["Decision"] = "decision";
  NodeType["Process"] = "process";
  NodeType["Start"] = "start";
  NodeType["End"] = "end";
  NodeType["Wait"] = "wait";
  return NodeType;
}({});
var Outcome = z.object({
  id: z.string(),
  displayName: z.string(),
  data: z.object({
    type: z.literal('object'),
    properties: z.record(z.string(), z.union([QuestionOptionsPropertySchema, z.object({
      type: z.literal('string'),
      title: z.string()
    })]).optional()).refine(function (obj) {
      return Object.keys(obj).length === 1;
    }, 'We currently only support one outcome data per outcome')
  }).nullish()
});
export var Workflow = z.object({
  nodes: z.array(z.object({
    id: z.string(),
    position: z.object({
      x: z.number(),
      y: z.number()
    }),
    type: z.nativeEnum(NodeType),
    data: z.object({
      templateId: z.string().optional(),
      properties: z.record(z.string(), z.unknown()).optional(),
      outcomes: z.array(Outcome).optional()
    })
  })),
  edges: z.array(z.object({
    id: z.string(),
    source: z.string(),
    sourceHandle: z.string().optional(),
    target: z.string()
  }))["default"]([])
});